import { useEffect, useState } from 'react';
import { DEFAULT_SECTIONS_OPEN, sectionElementId } from './sections';

const FOCUSABLE = 'input:not([aria-hidden="true"]):not([type="hidden"]), textarea, [tabindex="0"]';

const focusableControl = element =>
    element?.matches(FOCUSABLE) ? element : element?.closest('.MuiInputBase-root')?.querySelector(FOCUSABLE);

const scrollToTarget = ({ section, field }) => {
    const sectionElement = document.getElementById(sectionElementId(section));
    const fieldElement = field ? focusableControl(sectionElement?.querySelector(`[name="${field}"]`)) : null;
    if (fieldElement) {
        fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        fieldElement.focus({ preventScroll: true });
    } else {
        sectionElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};

const useFormSections = sessionKey => {
    const [sectionsOpen, setSectionsOpen] = useState(DEFAULT_SECTIONS_OPEN);
    const [pendingReveal, setPendingReveal] = useState(null);

    useEffect(() => {
        setSectionsOpen(DEFAULT_SECTIONS_OPEN);
    }, [sessionKey]);

    useEffect(() => {
        if (!pendingReveal) return;
        scrollToTarget(pendingReveal);
        setPendingReveal(null);
    }, [pendingReveal]);

    const toggleSection = key => setSectionsOpen(prev => ({ ...prev, [key]: !prev[key] }));

    const revealField = ({ section, field }) => {
        setSectionsOpen(prev => ({ ...prev, [section]: true }));
        setPendingReveal({ section, field });
    };

    return { sectionsOpen, toggleSection, revealField };
};

export default useFormSections;
